import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";

import barIcon from "../../assets/icon/baricon.svg";
import brandLogo from "../../assets/logo/brandLogo.png";
import theme from "../../Utils/theme";
import Footer from "../../components/Footer";
import Required from "../../components/Required";
import {
  getDepartmentDetail,
  saveUserDetail,
  Signout,
} from "../../api/User/Auth/registerApi";
import { getRegionDetail } from "../../api/User/commonApi";
import Fontstyling from "../../components/common/comman";
import ReactTooltip from "react-tooltip";
import { GrClose } from "react-icons/gr";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import Leftdrawer from "../../components/common/Drawer/LeftDrawer";

const Register = ({ navigate }) => {
  const { state } = useLocation();
  const [show, setShow] = useState(false);
  const [superRegion, setSuperRegion] = useState([]);
  const [hubRegion, setHubRegion] = useState([]);
  const [allHubRegion, setAllHubRegion] = useState([]);
  const [multipleHubRegion, setMultipleHubRegion] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [localRegion, setLocalRegion] = useState([]);
  const [departmentName, setDepartmentName] = useState([]);
  const [selectedSuperRegion, setSelectedSuperRegion] = useState("");
  const [selectedHubRegion, setSelectedHubRegion] = useState("");
  const [selectedLocalRegion, setSelectedLocalRegion] = useState("");
  const [open, setOpen] = useState(false);

  const [multipleHubRegionData, setMultipleHubRegionData] = useState([]);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const [inputValue, setInputValue] = useState({
    email: state?.email,
    empName: state?.name,
    hubLocalRegion: "",
    hubRegion: "",
    hubSuperRegion: "",
    department: "",
    telephoneNumber: "",
    financialConsultingLead: undefined,
    clinicalConsultingLead: undefined,
    healthAndPerformanceLead: undefined,
  });
  const {
    email,
    empName,
    hubLocalRegion,
    hubSuperRegion,
    department,
    telephoneNumber,
    financialConsultingLead,
    clinicalConsultingLead,
    healthAndPerformanceLead,
  } = inputValue;

  const [validationError, setValidationError] = useState({
    hubSuperRegionError: "",
    hubRegionError: "",
    hubLocalRegionError: "",
    departmentError: "",
    telephoneNumberError: "",
    financialConsultingLeadError: undefined,
    clinicalConsultingLeadError: undefined,
    healthAndPerformanceLeadError: undefined,
  });
  const {
    hubSuperRegionError,
    hubRegionError,
    hubLocalRegionError,
    departmentError,
    telephoneNumberError,
    financialConsultingLeadError,
    clinicalConsultingLeadError,
    healthAndPerformanceLeadError,
  } = validationError;

  //  if (!state?.email) {
  //  navigate("/login");
  //  }
  useEffect(() => {
    getRegionData();
    getDepartmentData();
  }, []);
  const getRegionData = async () => {
    await getRegionDetail()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setRegionData(res.data);
          let seen = new Set();
          const uniqArr = res.data.filter((obj) => {
            if (!seen.has(obj.hubRegion)) {
              seen.add(obj.hubRegion);
              return true;
            }
            return false;
          });
          // console.log(uniqueAllRegiona)
          // let uniqueAllRegion = [
          //   ...new Set(
          // res.data.map((region) => {
          //   if (region.hubRegion) {
          //     return {
          //       value: region.regionID,
          //       label: region.hubRegion,
          //     };
          //   }
          // })
          //   ),
          // ];
          // let uniqueAllRegionArr = uniqueAllRegion.map((data) => ({
          //   value: data,
          //   label: data,
          // }));
          setAllHubRegion((p) =>
            uniqArr.map((region) => {
              return {
                value: region.regionID,
                label: region.hubRegion,
              };
            })
          );
          setMultipleHubRegionData((p) =>
            uniqArr
              .filter((data) => data.regionID !== -1)
              .map((region) => {
                return {
                  value: region.regionID,
                  label: region.hubRegion,
                };
              })
          );

          setSuperRegion(
            [...new Set(res.data.map((el) => el.hubSuperRegion))].sort()
          );
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };
  const getDepartmentData = async () => {
    await getDepartmentDetail()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setDepartmentName(() =>
            res.data.sort((a, b) => {
              if (a.deptname < b.deptname) {
                return -1;
              }
              if (a.deptname > b.deptname) {
                return 1;
              }
              return 0;
            })
          );
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const handleChange = (e, element) => {
    let value = e.target.value;
    if (e.target.name === "telephoneNumber") {
      setValidationError((prev) => ({
        ...prev,
        telephoneNumberError: "",
      }));
    }

    if (element === "super") {
      setSelectedSuperRegion(e.target.value);
      let data = regionData.filter(
        (el) => el.hubSuperRegion === e.target.value
      );
      let uniqueData = [...new Set(data.map((region) => region.hubRegion))];
      let uniqArr = uniqueData.map((data) => ({ value: data, label: data }));

      setHubRegion(
        [
          ...new Set(
            regionData
              .filter((el) => el.hubSuperRegion === e.target.value)
              .map((el2) => el2.hubRegion)
          ),
        ].sort()
      );
      setSelectedHubRegion("");
      setSelectedLocalRegion("");
      setLocalRegion([]);
    } else if (element === "hub") {
      setSelectedHubRegion(e.target.value);
      setLocalRegion(
        [
          ...new Set(
            regionData.filter((el) => el.hubRegion === e.target.value)
          ),
        ].sort()
      );
      setAllHubRegion((pre) =>
        [
          ...new Set(
            multipleHubRegionData.filter((el) => el.label !== e.target.value)
          ),
        ].sort()
      );
      setMultipleHubRegion((prev) =>
        [...new Set(prev.filter((el) => el.label !== e.target.value))].sort()
      );
      setSelectedLocalRegion("");
    } else if (element === "local") {
      setSelectedLocalRegion(e.target.value);
    }
    setInputValue((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleDepartmentChange = (e) => {
    setInputValue((prev) => ({ ...prev, department: e.target.value }));
  };

  const handleSubmit = async (e, value) => {
    e.preventDefault();
    if (
      !selectedSuperRegion ||
      !selectedHubRegion ||
      !selectedLocalRegion ||
      !department ||
      !telephoneNumber ||
      !financialConsultingLead ||
      !clinicalConsultingLead ||
      !healthAndPerformanceLead ||
      telephoneNumber.length !== 10
    ) {
      if (!selectedSuperRegion) {
        setValidationError((prev) => ({
          ...prev,
          hubSuperRegionError: "required",
        }));
      }
      if (!selectedHubRegion) {
        setValidationError((prev) => ({
          ...prev,
          hubRegionError: "required",
        }));
      }
      if (!selectedLocalRegion) {
        setValidationError((prev) => ({
          ...prev,
          hubLocalRegionError: "required",
        }));
      }
      if (!department) {
        setValidationError((prev) => ({
          ...prev,
          departmentError: "required",
        }));
      }
      if (!telephoneNumber) {
        setValidationError((prev) => ({
          ...prev,
          telephoneNumberError: "required",
        }));
      } else if (telephoneNumber.length !== 10) {
        setValidationError((prev) => ({
          ...prev,
          telephoneNumberError: "incorrect number",
        }));
      }
      if (!financialConsultingLead) {
        setValidationError((prev) => ({
          ...prev,
          financialConsultingLeadError: "required",
        }));
      }
      if (!clinicalConsultingLead) {
        setValidationError((prev) => ({
          ...prev,
          clinicalConsultingLeadError: "required",
        }));
      }
      if (!healthAndPerformanceLead) {
        setValidationError((prev) => ({
          ...prev,
          healthAndPerformanceLeadError: "required",
        }));
      }
    } else {
      let payload = {
        UD_emp_email: state?.email,
        UD_emp_name: empName,
        UD_region_id: multipleHubRegion.length
          ? `${selectedLocalRegion.toString()},${multipleHubRegion
              .map((el) => el.value)
              .join(",")}`
          : selectedLocalRegion.toString(),
        UD_department_id: parseInt(department),
        UD_telephone_no: telephoneNumber.toString(),
        UD_is_financial_consulting_lead:
          financialConsultingLead === "true" ? true : false,
        UD_is_clinical_consulting_lead:
          clinicalConsultingLead === "true" ? true : false,
        UD_is_health_and_performance_lead:
          healthAndPerformanceLead === "true" ? true : false,
        UD_is_accepted: value,
        uD_IsActive: true,
      };
      await saveUserDetail(payload)
        .then((res) => {
          if (res?.status === 200) {
            navigate("/Welcome", {
              state: {
                email: state?.email,
                name: state?.name,
              },
            });
          }
        })
        .catch((err) => {
          console.log({ err });
        });
      setValidationError({
        hubLocalRegionError: "",
        departmentError: "",
        telephoneNumberError: "",
        financialConsultingLeadError: "",
        clinicalConsultingLeadError: "",
        healthAndPerformanceLeadError: "",
      });
    }
  };

  const handelReject = (e) => {
    e.preventDefault();
    Signout()
      .then((res) => {
        if (res?.status === 200) {
          navigate("/");
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/");
        }
      });
  };
  const Registration_Menu = [
    {
      title: "Registration Details",
      id: 1,
    },
  ];

  const toggleDrawer = () => {
    setShow(!show);
  };

  return (
    <div
      className="vw-100 vh-100"
      style={{ backgroundColor: theme.PRIMARY_ARCTIC_GRAY }}
    >
      <nav
        className="navbar bg-body-tertiary pe-4 py-3"
        style={{ borderBottom: "1px solid black" }}
      >
        <div className="container-fluid gap-3 flex-nowrap text-nowrap">
          <Link
            to={"/"}
            className="navbar-brand d-flex align-items-start ps-1"
          >
           <img
              src={brandLogo}
              width="260"
              alt="logo"
              className="img-fluid me-2"
            />
            {/* <div className="fs-4 Gotham-Black">Infused Analytics</div> */}
          </Link>
          {/* <div
 className="d-flex gap-4 align-items-center"
 style={{ overflowX: "scroll" }}
 >
 <button className="btn" style={{ fontWeight: "800" }}>
 Service Request
 </button>
 <button className="primary-button ms-4 py-2 px-4">Admin</button>
 </div> */}
          {/* <div
 className=" d-none d-sm-flex gap-md-3 gap-sm-2 gap-1 gap-lg-4 align-items-center hide-scrollbar "
 style={{ overflowX: "scroll" }}
 >
 <button className="btn" style={{ fontWeight: "800" }}>
 Service Request
 </button>
 <button className="primary-button ms-4 py-2 px-4" onClick={()=>navigate('/admin')}>Admin</button>
 </div> */}
          {/* <img
 src={barIcon}
 width="32"
 alt="barIcon"
 className="d-sm-none"
 onClick={() => setShow(true)}
 /> */}
        </div>
      </nav>
      {/* <Drawer
 open={show}
 onClose={toggleDrawer}
 direction="right"
 className="bla bla bla"
 duration="500"
 >
 <div className="text-end me-4 pt-2 fs-4">
 <GrClose onClick={toggleDrawer} />
 </div>
 <hr />
 <div
 className=" d-flex flex-column gap-md-3 gap-sm-2 gap-1 gap-lg-4 align-items-start hide-scrollbar "
 style={{ overflowX: "scroll" }}
 >
 <button className="btn ms-1" style={{ fontWeight: "800" }}>
 Service Request
 </button>
 <button className="primary-button ms-3 py-2 px-4">Admin</button>
 </div>
 </Drawer> */}
      <div
        className="text-end my-2 d-flex justify-content-between align-items-center px-2"
        style={Fontstyling.secondaryparagraph}
      >
        <div>
          <img
            src={barIcon}
            width="32"
            alt="barIcon"
            onClick={() => setOpen(true)}
            className="d-md-none"
          />
        </div>

        <div className="text-nowrap">
          Note: All fields marked with an (
          <Required />) are required for Registration.
        </div>
      </div>
      <main className="d-flex pe-md-4 pe-0" style={{ height: "80vh" }}>
        <div className="card sidebar me-3 rounded-0 border-0 d-none d-md-flex ">
          {/* <img src={barIcon} width="32" alt="barIcon" className="me-3 d-lg-none " onClick={handleShow} /> */}
          {/* <Offcanvas
 show={show}
 onHide={handleClose}
 className="d-sm-flex d-md-none"
 style={{ width: "200px", marginTop: "75px" }}
 >
 <Offcanvas.Body>
 <div
 className="d-flex align-items-center ps-1 mt-3"
 onClick={() => setShow(!show)}
 >
 <img src={barIcon} width="24" alt="barIcon" className="me-3" />
 <div
 className="fw-bold text-nowrap lh-lg"
 style={{
 ...Fontstyling.sidebarheading,
 color: theme.SECONDARY_SHOCKING_BLUE,
 }}
 >
 Registration Details
 </div>
 </div>
 </Offcanvas.Body>
 </Offcanvas> */}

          <div className=" align-items-center ps-1 mt-3 d-none d-lg-flex ">
            <img src={barIcon} width="32" alt="barIcon" className="me-3" />
            <div
              className="fw-bold text-nowrap lh-lg"
              style={{ color: theme.SECONDARY_SHOCKING_BLUE }}
            >
              Registration Details
            </div>
          </div>

          {/* <div className="d-flex align-items-center ps-1 mt-3 d-none d-md-flex ">
 <img src={barIcon} width="32" alt="barIcon" className="me-3" />
 <div
 className="fw-bold text-nowrap lh-lg"
 style={{ color: theme.SECONDARY_SHOCKING_BLUE }}
 // onClick={() => setOpen(!open)}
 >
 Registration Details
 </div>
 </div> */}
        </div>
        <Leftdrawer open={open} setOpen={setOpen} data={Registration_Menu} />
        <div className="card overflow-auto w-100 p-4 rounded-0 border-0">
          <div className="mb-3" style={Fontstyling.heading}>
            Registration Details:
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Employee E-Mail
                </label>
                <input
                  type="email"
                  className="form-control rounded-0 py-1"
                  style={{
                    ...Fontstyling.label,
                  }}
                  value={email}
                  name="email"
                  onChange={handleChange}
                  placeholder="Employee E-Mail"
                  disabled
                />
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Employee Name
                </label>
                <input
                  type="text"
                  value={empName}
                  name="empName"
                  onChange={handleChange}
                  className="form-control rounded-0 py-1"
                  style={Fontstyling.label}
                  placeholder="Employee Name"
                  disabled
                />
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Super Region
                  <Required />
                </label>
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="superRegion"
                  value={selectedSuperRegion}
                  style={Fontstyling.label}
                  onChange={(e) => handleChange(e, "super")}
                >
                  <option selected value="">
                    Select One
                  </option>
                  {superRegion.map((item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ))}
                </select>
                {!selectedSuperRegion && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {hubSuperRegionError}
                  </label>
                )}
              </div>
              <div className="col px-1">
                <label
                  htmlFor="hubregion"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Hub Region
                  <Required />
                </label>
                <img
                  data-tip="You can add more then one region from additional Hub Region"
                  src={require("../../assets/icon/Question_mark_back.png")}
                  style={{ height: 12, marginLeft: 3 }}
                />
                <ReactTooltip />
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="hubRegion"
                  value={selectedHubRegion}
                  style={Fontstyling.label}
                  onChange={(e) => handleChange(e, "hub")}
                >
                  <option selected value="">
                    Select One
                  </option>
                  {hubRegion.map((item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ))}
                </select>
                {!selectedHubRegion && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {hubRegionError}
                  </label>
                )}
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  HUB Local Region
                  <Required />
                </label>
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="hubLocalRegion"
                  value={selectedLocalRegion}
                  style={Fontstyling.label}
                  onChange={(e) => handleChange(e, "local")}
                >
                  <option selected value="">
                    Select One
                  </option>
                  {localRegion.map((item, index) => (
                    <option value={item.regionID} key={index}>
                      {item.hubLocal}
                    </option>
                  ))}
                </select>
                {!selectedLocalRegion && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {hubLocalRegionError}
                  </label>
                )}
              </div>
            </div>

            <div className="row mb-2 d-wrap">
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Department / Function
                  <Required />
                </label>
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="department"
                  value={department}
                  onChange={handleDepartmentChange}
                  style={Fontstyling.label}
                >
                  <option selected value="">
                    Select One
                  </option>
                  {departmentName.map((item, index) => (
                    <option value={item.deptID} key={index}>
                      {item.deptname}
                    </option>
                  ))}
                </select>
                {!department && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {departmentError}
                  </label>
                )}
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Telephone Number
                  <Required />
                </label>
                <input
                  type="text"
                  value={telephoneNumber}
                  name="telephoneNumber"
                  onChange={handleChange}
                  className="form-control rounded-0 py-1"
                  style={Fontstyling.label}
                  placeholder="Telephone Number"
                  maxLength={"10"}
                />
                {telephoneNumberError && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {telephoneNumberError}
                  </label>
                )}
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Financial Consulting Lead?
                  <Required />
                </label>
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="financialConsultingLead"
                  value={financialConsultingLead}
                  style={Fontstyling.label}
                  onChange={handleChange}
                >
                  <option selected value="">
                    Select One
                  </option>
                  <option value={true}> Yes </option>
                  <option value={false}> No </option>
                </select>
                {!financialConsultingLead && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {financialConsultingLeadError}
                  </label>
                )}
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Clinical Consulting Lead?
                  <Required />
                </label>
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="clinicalConsultingLead"
                  value={clinicalConsultingLead}
                  style={Fontstyling.label}
                  onChange={handleChange}
                >
                  <option selected value="">
                    Select One
                  </option>
                  <option value={true}> Yes </option>
                  <option value={false}> No </option>
                </select>
                {!clinicalConsultingLead && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {clinicalConsultingLeadError}
                  </label>
                )}
              </div>
              <div className="col px-1">
                <label
                  htmlFor="inputEmail4"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Health and Performance Lead?
                  <Required />
                </label>
                <select
                  id="inputState"
                  className="form-select rounded-0 py-1"
                  name="healthAndPerformanceLead"
                  value={healthAndPerformanceLead}
                  style={Fontstyling.label}
                  onChange={handleChange}
                >
                  <option selected value="">
                    Select One
                  </option>
                  <option value={true}> Yes </option>
                  <option value={false}> No </option>
                </select>
                {!healthAndPerformanceLead && (
                  <label
                    htmlFor="inputEmail4"
                    style={Fontstyling.errorlabel}
                    className="form-label text-nowrap text-danger"
                  >
                    {healthAndPerformanceLeadError}
                  </label>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-4 px-1">
                <label
                  htmlFor="hubregion"
                  style={Fontstyling.label}
                  className="form-label text-nowrap"
                >
                  Additional Hub Region
                </label>
                <Select
                  isDisabled={selectedSuperRegion === "NATIONAL"}
                  name="multiRegion"
                  isMulti
                  value={multipleHubRegion}
                  className="py-0 rounded-0"
                  options={allHubRegion}
                  onChange={(selectedOption) => {
                    setMultipleHubRegion(selectedOption);
                  }}
                  styles={{
                    control: (base, { isDisabled }) => ({
                      ...Fontstyling.primaryparagraph,
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ced4da",
                      width: "auto",
                      // maxHeight: "30px",
                      height: "auto",
                      textAlign: "left",
                      backgroundColor: isDisabled ? "#e9ecef" : "",
                    }),
                    option: (
                      styles,
                      { data, isDisabled, isFocused, isSelected }
                    ) => {
                      return {
                        ...styles,
                        ...Fontstyling.primaryparagraph,
                        textAlign: "left",
                      };
                    },
                  }}
                />
              </div>
            </div>

            <div className="mt-5">
              <div style={{ ...Fontstyling.heading }}>
                Terms of Use Agreement / End User Agreement <Required />
              </div>
              <p
                className="fw-normal mt-3 lh-2"
                style={Fontstyling.primaryparagraph}
              >
                By click Accept below, I hereby attest that I completed the
                required Health Insurance Portability and Accountability Act of
                1996 (HIPAA) Privacy training as required under 45 CFR 164.530
                (Administrative Requirements) and as provided by Human Resources
                and HUB International Compliance. I understand that my rights
                may be revoked and/or disciplinary action, up to and including
                termination of employment may result in any unlawful use or
                disclose of information contained within the HUB Infused
                Analytics system and/or any of its affiliated service providers.
                I understand that clients may also revoke or restrict my access
                to see, use, or disclose information pertaining to protected
                health information (PHI) of their employees and dependents of
                employees. Lastly, information within the HUB Infused Analytics
                platform is to be considered to be confidential and should be
                used under the minimum necessary standards provision as a part
                of HIPAA Privacy Regulations.
              </p>
              <p style={Fontstyling.primaryparagraph}>
                I understand that if I require or desire access to clients that
                are not directly connected to my HUB region that I may request
                access by selecting<strong> Other </strong> under
                <span
                  className="fw-bold"
                  style={{ color: theme.SECONDARY_SHOCKING_BLUE }}
                >
                  {" "}
                  Service Request{" "}
                </span>
                after registering my account.
              </p>
            </div>
            <div className="d-flex">
              <button
                className="primary-button me-2 px-5"
                onClick={(e) => handleSubmit(e, true)}
                type="submit"
              >
                Accept
              </button>
              <button className="secondary-button px-5" onClick={handelReject}>
                Reject
              </button>
            </div>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Register;
